/* RaceWerkz attribution capture v5.10.3. Install once sitewide via the earliest shared header location available.
 * No external analytics requests. No user contact details or arbitrary URL queries are collected.
 * Attribution/click-ID storage and transfer require Shopify marketing permission.
 */
(() => {
  if (window.RacewerkzAttribution?.version >= 6) return;
  const KEY = 'rwz_attribution_v3';
  const SESSION_KEY = 'rwz_session_attribution_v3';
  const FALLBACK_KEY = 'rwz_attribution_session_fallback_v1';
  const JOURNEY_SESSION_KEY = 'rwz_journey_session_v1';
  const JOURNEY_PRODUCTS_KEY = 'rwz_recent_products_v1';
  const JOURNEY_TTL = 30 * 24 * 60 * 60 * 1000;
  const TTL = 90 * 24 * 60 * 60 * 1000;
  const FIELDS = [
    'utm_source','utm_medium','utm_campaign','utm_id','utm_content','utm_term',
    'utm_source_platform','utm_creative_format','utm_marketing_tactic',
    'gclid','gbraid','wbraid','dclid','gad_source','gad_campaignid',
    'fbclid','msclkid','ttclid','li_fat_id','twclid','sccid','epik','rdt_cid',
    'campaign_id','campaign_name','adset_id','adset_name','ad_id','ad_name','adgroup_id','creative_id',
    'placement','source_platform','network','device','matchtype'
  ];
  const CLICK_KEYS = ['gclid','gbraid','wbraid','dclid','fbclid','msclkid','ttclid','li_fat_id','twclid','sccid','epik','rdt_cid'];
  const ALL_KEYS = new Set(FIELDS);
  const SOURCE_DOMAINS = [
    [/^(?:www\.)?(?:google\.[a-z.]+|googleusercontent\.com)$/i,'google','organic_search'],
    [/^(?:www\.)?bing\.com$/i,'bing','organic_search'],
    [/^(?:search\.|www\.)?yahoo\.com$/i,'yahoo','organic_search'],
    [/^(?:www\.)?duckduckgo\.com$/i,'duckduckgo','organic_search'],
    [/^(?:www\.)?brave\.com$/i,'brave','organic_search'],
    [/^(?:www\.)?ecosia\.org$/i,'ecosia','organic_search'],
    [/^(?:www\.)?yandex\.[a-z.]+$/i,'yandex','organic_search'],
    [/^(?:www\.|m\.|l\.|lm\.|web\.)?(?:facebook\.com|instagram\.com|fb\.com)$/i,'meta','social_unpaid_or_unknown'],
    [/^(?:www\.|m\.)?(?:tiktok\.com)$/i,'tiktok','social_unpaid_or_unknown'],
    [/^(?:www\.)?(?:reddit\.com)$/i,'reddit','social_unpaid_or_unknown'],
    [/^(?:www\.)?(?:youtube\.com|youtu\.be)$/i,'youtube','social_unpaid_or_unknown'],
    [/^(?:www\.)?(?:linkedin\.com|lnkd\.in)$/i,'linkedin','social_unpaid_or_unknown'],
    [/^(?:www\.)?(?:pinterest\.com|pin\.it)$/i,'pinterest','social_unpaid_or_unknown'],
    [/^(?:www\.)?(?:x\.com|twitter\.com|t\.co)$/i,'x','social_unpaid_or_unknown']
  ];
  const attrText = (v, max = 160) => typeof v === 'string' ? v.replace(/[\u0000-\u001f\u007f]/g, '').trim().slice(0,max) : '';
  function cleanUrl(input, max = 500) {
    try {
      const u = new URL(input, window.location.origin);
      if (u.protocol !== 'https:' && u.protocol !== 'http:') return '';
      // Deliberately omit query and hash to avoid accidentally collecting emails, tokens, etc.
      return attrText(u.origin + u.pathname, max);
    } catch { return ''; }
  }
  function safeLocalStorage() { try { return window.localStorage; } catch { return null; } }
  function safeSessionStorage() { try { return window.sessionStorage; } catch { return null; } }
  function consent() {
    try {
      const cp = window.Shopify?.customerPrivacy;
      if (cp && typeof cp.marketingAllowed === 'function') {
        const allowed = cp.marketingAllowed();
        // During Shopify API initialization, an undefined result is not a denial.
        if (allowed === true) return 'granted';
        if (allowed === false) return 'denied';
      }
    } catch { /* fail closed */ }
    return 'unavailable';
  }
  function clear() {
    try { localStorage.removeItem(KEY); } catch {}
    try { sessionStorage.removeItem(SESSION_KEY); } catch {}
    try { sessionStorage.removeItem(FALLBACK_KEY); } catch {}
    try { sessionStorage.removeItem(JOURNEY_SESSION_KEY); } catch {}
    try { localStorage.removeItem(JOURNEY_PRODUCTS_KEY); } catch {}
    memoryAttribution=null; memoryJourney=null; memoryProducts=null;
    // Discard any pre-permission context after a definitive denial.
    pendingEntry=null;
  }
  function parseStore(store, key) {
    try {
      const raw = store.getItem(key);
      const obj = raw ? JSON.parse(raw) : null;
      if (!obj || obj.version !== 3 || !obj.updatedAt || (Date.now()-obj.updatedAt) > TTL || obj.updatedAt > Date.now()+60000) return null;
      return obj;
    } catch { return null; }
  }
  function saveStore(store, key, obj) { try { if (!store) return false; store.setItem(key, JSON.stringify(obj)); return true; } catch { return false; } }
  function getReferrer() {
    const ref = document.referrer || '';
    if (!ref) return { url:'', external:false, hostname:'' };
    try {
      const url = new URL(ref);
      const host = url.hostname.toLowerCase();
      const current = window.location.hostname.toLowerCase();
      const internal = host === current ||
        ['racewerkz.com','www.racewerkz.com'].includes(host) ||
        (host.endsWith('.myshopify.com') && current.endsWith('.myshopify.com'));
      return { url:cleanUrl(ref, 500), external:!internal, hostname:host };
    } catch { return { url:'', external:false, hostname:'' }; }
  }
  function classify(params, ref) {
    const has = k => !!params[k];
    const uSource = (params.utm_source || '').toLowerCase();
    const medium = (params.utm_medium || '').toLowerCase();
    const tagged = !!FIELDS.some(k => params[k]);
    if (has('gclid') || has('gbraid') || has('wbraid') || has('dclid')) return {source:'google', channel:'google_ads_paid', evidence:'google_click_id', confidence:'high'};
    if (has('fbclid')) return {source:'meta',channel:/^(cpc|ppc|paid|paid_social|paidsocial|social_paid)$/.test(medium)?'paid_social':'meta_click_unknown_paid_or_organic',evidence:'meta_click_id',confidence:medium?'high':'medium'};
    if (has('msclkid')) return {source:'microsoft',channel:'paid_search',evidence:'microsoft_click_id',confidence:'high'};
    if (has('ttclid')) return {source:'tiktok',channel:/^(cpc|ppc|paid|paid_social|paidsocial|social_paid)$/.test(medium)?'paid_social':'tiktok_click_unknown_paid_or_organic',evidence:'tiktok_click_id',confidence:medium?'high':'medium'};
    if (has('li_fat_id')) return {source:'linkedin',channel:'paid_social',evidence:'linkedin_click_id',confidence:'high'};
    if (has('twclid')) return {source:'x',channel:'x_click_unknown_paid_or_organic',evidence:'x_click_id',confidence:'medium'};
    if (has('sccid')) return {source:'snapchat',channel:'snapchat_click_unknown_paid_or_organic',evidence:'snapchat_click_id',confidence:'medium'};
    if (has('epik')) return {source:'pinterest',channel:'pinterest_click_unknown_paid_or_organic',evidence:'pinterest_click_id',confidence:'medium'};
    if (has('rdt_cid')) return {source:'reddit',channel:'reddit_click_unknown_paid_or_organic',evidence:'reddit_click_id',confidence:'medium'};
    if (tagged) {
      let channel='tagged_unknown';
      if (/^(cpc|ppc|paid|paid_social|paidsocial|paid-search|paid_search|display|retargeting|remarketing|social_paid|cp[amv])$/.test(medium)) channel='paid';
      else if (/^(organic|organic_search|seo)$/.test(medium)) channel='organic_search';
      else if (/^(email|e-mail)$/.test(medium)) channel='email';
      else if (/^(social|social_media|organic_social)$/.test(medium)) channel='social_unpaid_or_unknown';
      else if (/^(referral|affiliate|partner)$/.test(medium)) channel='referral';
      return {source:uSource||'tagged_unknown',channel,evidence:'utm_or_campaign_parameters',confidence:medium?'medium':'low'};
    }
    if (ref.external) {
      for (const [regex,source,channel] of SOURCE_DOMAINS) {
        if (regex.test(ref.hostname)) return {source,channel,evidence:'external_referrer',confidence:'medium'};
      }
      return {source:ref.hostname,channel:'referral',evidence:'external_referrer',confidence:'medium'};
    }
    return {source:'direct_or_unknown',channel:'direct_or_unknown',evidence:'no_identifiable_source',confidence:'low'};
  }
  function makeTouch() {
    const params = {};
    const search = new URLSearchParams(window.location.search);
    for (const [rawKey,rawValue] of search) {
      const k=rawKey.toLowerCase();
      if (!ALL_KEYS.has(k) || params[k]) continue;
      const v=attrText(rawValue, CLICK_KEYS.includes(k) ? 256 : 160);
      if (v) params[k]=v;
    }
    const ref = getReferrer();
    return {
      ...classify(params,ref),
      capturedAt: new Date().toISOString(),
      landingPage: cleanUrl(window.location.href,500),
      referrer: ref.external ? ref.url : '',
      params
    };
  }
  // Snapshot the *document entry*, while the landing URL and external referrer are still
  // present. Do not write or transmit it until marketing permission is granted.
  // On explicit denial, clear() destroys this temporary in-memory context as well.
  let pendingEntry = makeTouch();
  function capture() {
    const permission = consent();
    if (permission === 'denied') { clear(); return; }
    if (permission !== 'granted') return; // API unavailable must not erase saved attribution.
    const candidate = pendingEntry || makeTouch();
    const previous = readAttribution();
    const session = parseStore(safeSessionStorage(), SESSION_KEY);
    const identifiable = candidate.evidence !== 'no_identifiable_source';
    const now=Date.now();
    updateJourney();
    // Session attribution must be captured even when this visit has the same URL/UTMs
    // as the last stored touch from a previous session. Otherwise new sessions go blank.
    if (!session) saveStore(safeSessionStorage(),SESSION_KEY,{version:3,updatedAt:now,sessionTouch:candidate});
    // Internal page views with no identifiable source should not replace the last
    // meaningful marketing source just because the customer browsed to another page.
    if (!identifiable && session) return;
    const last=previous?.lastTouch;
    if (last && last.landingPage===candidate.landingPage && last.referrer===candidate.referrer &&
        last.evidence===candidate.evidence && JSON.stringify(last.params)===JSON.stringify(candidate.params)) return;
    const next={
      version:3,updatedAt:now,
      firstTouch: previous?.firstTouch || candidate,
      firstIdentifiableTouch: previous?.firstIdentifiableTouch ||
        (previous?.firstTouch?.evidence !== 'no_identifiable_source' ? previous?.firstTouch : null) ||
        (identifiable ? candidate : null),
      lastTouch: candidate,
      lastNonDirectTouch: identifiable ? candidate : (previous?.lastNonDirectTouch || null)
    };
    memoryAttribution=next;
    if (!saveStore(safeLocalStorage(),KEY,next)) saveStore(safeSessionStorage(),FALLBACK_KEY,next);
  }
  // A referrer from our own storefront is NOT a new traffic source, but it is
  // valid evidence of the immediately preceding page. V5.8 threw this away.
  function internalPreviousPage() {
    try {
      const ref = new URL(document.referrer);
      const current = new URL(window.location.href);
      const allowed = ['racewerkz.com','www.racewerkz.com'];
      if (ref.protocol !== 'https:' || !allowed.includes(ref.hostname.toLowerCase()) ||
          !allowed.includes(current.hostname.toLowerCase())) return '';
      return relevantPage(ref);
    } catch { return ''; }
  }
  function relevantPage(input) {
    try {
      const u = input instanceof URL ? input : new URL(input, window.location.origin);
      const path = u.pathname;
      // Don't retain account, checkout, cart, search query or arbitrary customer routes.
      if (!/^\/(?:products|collections|pages)(?:\/|$)/.test(path)) return '';
      if (/\/(?:account|checkout|cart|challenge|search)(?:\/|$)/i.test(path)) return '';
      return attrText(u.origin + path,500);
    } catch { return ''; }
  }
  function parseJourney(store,key) {
    try {
      const value = store && JSON.parse(store.getItem(key));
      if (!value || value.version !== 1 || typeof value.updatedAt !== 'number' ||
          value.updatedAt>Date.now()+60000 || Date.now()-value.updatedAt>JOURNEY_TTL) return null;
      return value;
    } catch { return null; }
  }
  let memoryJourney = null;
  let memoryProducts = null;
  let memoryAttribution = null;
  let lastJourneyProcessedPage = null;
  function journeyView(j, products) {
    return {
      firstObservedPage:j.firstObservedPage||'',
      firstObservedAt:j.firstObservedAt||'',
      previousPage:j.previousPage||'',
      previousPageEvidence:j.previousPageEvidence||'',
      recentPages:(j.pages||[]).slice(-12),
      recentProducts:(products.items||[]).slice(-8)
    };
  }
  function updateJourney() {
    if (consent() !== 'granted') return null;
    const page=relevantPage(window.location.href);
    if (lastJourneyProcessedPage === page) {
      const j=memoryJourney || parseJourney(safeSessionStorage(),JOURNEY_SESSION_KEY);
      const products=memoryProducts || parseJourney(safeLocalStorage(),JOURNEY_PRODUCTS_KEY);
      if (j && products) return journeyView(j,products);
    }
    const prior=internalPreviousPage();
    const now=Date.now();
    const stored=parseJourney(safeSessionStorage(),JOURNEY_SESSION_KEY);
    const j=stored || memoryJourney || {version:1,firstObservedPage:page,firstObservedAt:new Date(now).toISOString(),pages:[],updatedAt:now};
    if (!Array.isArray(j.pages)) j.pages=[];
    const previouslyObservedPage = j.currentPage || j.pages.at(-1)?.page || '';
    // Document.referrer can recover a product page even when tracking started
    // too late to observe that page. Mark it as referrer evidence, not a tracked visit.
    if (prior && prior!==page && j.pages.at(-1)?.page!==prior && !j.pages.some(x=>x.page===prior)) {
      j.pages.push({page:prior,evidence:'internal_referrer'});
    }
    if (page && j.pages.at(-1)?.page!==page) j.pages.push({page,evidence:'tracker_observed'});
    j.pages=j.pages.slice(-12);
    j.currentPage=page;
    if (prior && prior!==page) {
      j.previousPage=prior;
      j.previousPageEvidence='internal_referrer';
    } else if (previouslyObservedPage && previouslyObservedPage!==page) {
      // When a referrer is suppressed, use the last actually observed page.
      // Refresh this on *each* new navigation, not only the first navigation.
      j.previousPage=previouslyObservedPage;
      j.previousPageEvidence='tracker_observed';
    }
    j.updatedAt=now;
    memoryJourney=j;
    saveStore(safeSessionStorage(),JOURNEY_SESSION_KEY,j);
    let products=parseJourney(safeLocalStorage(),JOURNEY_PRODUCTS_KEY) || memoryProducts || {version:1,updatedAt:now,items:[]};
    if (!Array.isArray(products.items)) products.items=[];
    const recordProduct=(url,evidence)=>{
      if (!/\/products\//.test(url)) return;
      products.items=products.items.filter(x=>x.page!==url);
      products.items.push({page:url,evidence,capturedAt:new Date(now).toISOString()});
    };
    // Recover an unobserved internal referrer, but never overwrite a product that
    // was already tracked (or its original observation timestamp/evidence).
    if (prior && !products.items.some(x=>x.page===prior)) recordProduct(prior,'internal_referrer');
    if (page && page!==lastJourneyProcessedPage) recordProduct(page,'tracker_observed');
    products.items=products.items.slice(-8);
    products.updatedAt=now;
    memoryProducts=products;
    saveStore(safeLocalStorage(),JOURNEY_PRODUCTS_KEY,products);
    lastJourneyProcessedPage=page;
    return journeyView(j,products);
  }
  function readAttribution() {
    // An accessible but read-only/quota-full localStorage may contain stale data.
    // Prefer the latest successfully captured value rather than silently reverting.
    const candidates=[parseStore(safeLocalStorage(),KEY),
      parseStore(safeSessionStorage(),FALLBACK_KEY),memoryAttribution].filter(Boolean);
    return candidates.reduce((best,x)=>(!best || x.updatedAt>=best.updatedAt ? x : best),null);
  }
  function readCookie(name) {
    try {
      const target=name+'=';
      const part=document.cookie.split(';').map(x=>x.trim()).find(x=>x.startsWith(target));
      return attrText(part ? decodeURIComponent(part.slice(target.length)) : '',256);
    } catch { return ''; }
  }
  function snapshot() {
    const permission=consent();
    // Submission page is operational context, not stored marketing attribution.
    const base = {consent:permission, submissionPage:cleanUrl(window.location.href,500)};
    if (permission === 'denied') clear();
    if (permission !== 'granted') return base; // Never expose attribution without permission.
    capture();
    const data = readAttribution();
    const session = parseStore(safeSessionStorage(),SESSION_KEY);
    return {
      ...base,
      firstTouch: data?.firstTouch || null,
      firstIdentifiableTouch: data?.firstIdentifiableTouch ||
        (data?.firstTouch?.evidence && data.firstTouch.evidence !== 'no_identifiable_source' ? data.firstTouch : null),
      lastTouch: data?.lastTouch || null,
      lastNonDirectTouch: data?.lastNonDirectTouch || null,
      sessionTouch: session?.sessionTouch || null,
      journey: updateJourney(),
      trackingDiagnostics: {
        trackerVersion:6,
        storage: parseStore(safeLocalStorage(),KEY) ? 'persistent' :
          (parseStore(safeSessionStorage(),FALLBACK_KEY) ? 'session_fallback' : 'memory_only'),
        firstCapturePage: data?.firstTouch?.landingPage || ''
      },
      browserIds: { metaFbc:readCookie('_fbc'), metaFbp:readCookie('_fbp') }
    };
  }
  // A form can be submitted while Shopify's privacy API is still initializing.
  // Wait briefly for a definitive consent state; do not block a valid inquiry indefinitely.
  function whenReady(timeoutMs = 1200) {
    const maxWait = Math.max(0, Math.min(Number(timeoutMs) || 0, 2000));
    if (consent() !== 'unavailable' || !maxWait) return Promise.resolve(consent());
    ensurePrivacyApi();
    return new Promise(resolve => {
      const started = Date.now();
      const timer = setInterval(() => {
        const state = consent();
        if (state !== 'unavailable' || Date.now() - started >= maxWait) {
          clearInterval(timer);
          if (state === 'granted') capture();
          resolve(state);
        }
      }, 50);
    });
  }
  window.RacewerkzAttribution = {version:6, capture, snapshot, classify, clear, whenReady};
  document.addEventListener('visitorConsentCollected', () => capture());
  // Per Shopify docs, explicitly request the Customer Privacy API. It may load later
  // than theme scripts or already exist because another Shopify feature loaded it.
  let privacyRequested=false;
  function ensurePrivacyApi() {
    if (consent()!=='unavailable') {capture();return true;}
    const loader=window.Shopify?.loadFeatures;
    if (typeof loader==='function' && !privacyRequested) {
      privacyRequested=true;
      try {
        loader([{name:'consent-tracking-api',version:'0.2'}], (error) => {
          if (!error) capture();
          else privacyRequested=false; // Retry only on the next readiness check.
        });
      } catch { privacyRequested=false; /* Inquiry still functions if privacy API is absent. */ }
      return true;
    }
    return privacyRequested;
  }
  if (!ensurePrivacyApi()) {
    let attempts=0;
    const timer=setInterval(() => {
      attempts++;
      if (ensurePrivacyApi() || attempts>=60) clearInterval(timer);
    },250);
  }
  // A missing privacy API during HTML parsing should not end the opportunity to
  // capture this document's original entry after Shopify becomes ready.
  document.addEventListener('DOMContentLoaded', ensurePrivacyApi);
  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) ensurePrivacyApi();
  });
  if (typeof window.addEventListener === 'function') {
    window.addEventListener('pageshow', ensurePrivacyApi);
    window.addEventListener('focus', ensurePrivacyApi);
  }
})();
